/*!
 * Copyright Optimus Ride 2018
 */

import { createBrowserHistory } from 'history';

export default createBrowserHistory({
    forceRefresh: false,
});
